enum InstitutionSortEnum {
  LastName = 1,
  FirstName = 2,  
  OIB = 3,
  RoleName = 4,
  InstitutionName = 5,
  InstitutionOIB = 6
}

export default InstitutionSortEnum;
